import { render, staticRenderFns } from "./timelinefull.vue?vue&type=template&id=4b5ffb68&scoped=true&"
import script from "./timelinefull.vue?vue&type=script&lang=js&"
export * from "./timelinefull.vue?vue&type=script&lang=js&"
import style0 from "./timelinefull.vue?vue&type=style&index=0&id=4b5ffb68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ffb68",
  null
  
)

export default component.exports